"use client";

import { usePostCoupon } from "@/api/AppApi/services/cart";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

function CouponFromQP() {
  const searchParams = useSearchParams();

  const coupon = searchParams.get("coupon");

  const postCoupon = usePostCoupon({ onSuccess: () => {}, onError: () => {} });

  useEffect(() => {
    if (coupon) {
      localStorage.setItem("coupon_referer", coupon);
      postCoupon.mutate({ code: coupon, country_code: "" });
    }
  }, [coupon]);

  return null;
}

export default CouponFromQP;
